import {Entity} from '../base/entity';

export class AppUser extends Entity {

  public static readonly TABLENAME = 'app_user';

  public static readonly ID = 'id';
  public static readonly FIRST_NAME = 'first_name';
  public static readonly LAST_NAME = 'last_name';
  public static readonly USERNAME = 'username';
  public static readonly PASSWORD = 'password';
  public static readonly LANG = 'lang';
  public static readonly VALID_FROM = 'valid_from';
  public static readonly VALID_TO = 'valid_to';
  public static readonly IP_ADDRESS = 'ip_address';
  public static readonly SECURITY_KEY = 'security_key';
  public static readonly CREATED_AT = 'created_at';
  public static readonly UPDATED_AT = 'updated_at';
  public static readonly DELETED_AT = 'deleted_at';

  id: number;
  firstName: string;
  lastName: string;
  username: string;
  password: string;
  lang: string;
  validFrom: Date;
  validTo: Date;
  ipAddress: string;
  securityKey: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;

  accessToken: string;
  roles: any[];
  grantedActivities: any[];

  public fullName(): string {
    return this.firstName + ' ' + this.lastName;
  }

  public get uiLang(): string {
    if (this.lang === 'en') {
      return 'en'
    } else if (this.lang === 'sr-l') {
      return 'sr-Latn'
    } else if (this.lang === 'sr-c') {
      return 'sr-Cyrl'
    } else {
      return 'sr-Latn'
    }
  }

  public set uiLang(val: string) {
    if (val === 'en') {
      this.lang = 'en';
    } else if (val === 'sr-Latn') {
      this.lang = 'sr-l';
    } else if (val === 'sr-Cyrl') {
      this.lang = 'sr-c';
    } else {
      this.lang = 'sr-l';
    }
  }
}
